import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../services/AuthService";
import config from "../config";

const PrivateRoute = ({ component: Component }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to={config.redirectRouteOnAuthenticationFaliure}
        replace
        state={{ from: location }}
      />
    );
  }

  return <Component />;
};

export default PrivateRoute;